import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const patientResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getPatient(to.params.id as string);
        to.meta.patient = res.data.data;
    } catch(error) {
        console.error('PATIENT_RESOLVER_ERROR');
        return { name: 'Patients' };
    }
}